import { render, staticRenderFns } from "./WorkspaceTopbar.vue?vue&type=template&id=b5db907a&scoped=true&"
import script from "./WorkspaceTopbar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5db907a",
  null
  
)

export default component.exports